//eg: 安卓 "https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan/encodeURIComponent(mvoicerwsm://open.mvoicer.com/300001?wsmtypespecial=1&content=wsprn=1002&wsrn=1002)"
//    iOS  https://applinks.xiyacs.com/wsm/300001?wsmtypespecial=1&content=wsprn=1002&wsrn=1002


let Base64 = require('js-base64').Base64;

export function appUrlAndroid(path, content) {
  if (content) {
    let contents = Base64.encode(content).replace(/\+\//g, "-*")
    return encodeURIComponent(`mvoicerwsm://open.mvoicer.com/${path}?wsmtypespecial=1&content=${contents}`)
  }
  return encodeURIComponent(`mvoicerwsm://open.mvoicer.com/${path}?wsmtypespecial=1`)
}

export function appUrlIOS(path, content) {
  if (content) {
    let contents = Base64.encode(content).replace(/\+\//g, "-*")
    return `https://applinks.woshimi.cn/wsm/${path}?wsmtypespecial=1&content=${contents}`
    // return `https://applinks.xiyacs.com/wsm/${path}?wsmtypespecial=1&content=${contents}`
  }
  return `https://applinks.woshimi.cn/wsm/${path}?wsmtypespecial=1`
  // return `https://applinks.xiyacs.com/wsm/${path}?wsmtypespecial=1`
}

export default {
  appUrlAndroid,
  appUrlIOS
}

































// export function wsmOpenApp(path,content){
//   if(content){
//        let contents= window.btoa(content).replace(/\+\//g,"-*")
//        return `mvoicerwsm://open.mvoicer.com/${path}?wsmTypespecil=1&content=${contents}`
//     }
//    return `mvoicerwsm://open.mvoicer.com/${path}?wsmTypespecil=1`
//  }





//第一版
// export function wsmOpenApp(path,content){
//   if(content){
//     let contents=Base64.encode(content).replace(/\+\//g,"-*")
//     return `mvoicerwsm://open.mvoicer.com/${path}?wsmtypespecial=1&content=${contents}`
//   }
//  return `mvoicerwsm://open.mvoicer.com/${path}?wsmtypespecial=1`
// }


// export default {
//   wsmOpenApp
// }



// WEBPACK FOOTER //
// ./src/assets/js/base64.js